import {ContentfulRiverAccordion} from '@github-ui/swp-core/components/contentful/ContentfulRiverAccordion'
import {ContentfulSectionIntro} from '@github-ui/swp-core/components/contentful/ContentfulSectionIntro'
import {Section} from '@primer/react-brand/esm'
import type {FeaturesSectionContent} from '../../content'
import {Cards} from '../../_components/Cards/Cards'

import styles from './FeaturesSection.module.css'

type Props = {
  contentfulContent: FeaturesSectionContent
}

export function FeaturesSection({contentfulContent}: Props) {
  const sectionId = contentfulContent.section.fields.htmlId
  const sectionIntro = contentfulContent.sectionIntro
  const riverAccordion = contentfulContent.riverAccordion
  const cards = contentfulContent.cards

  return (
    <Section id={sectionId} fullWidth paddingBlockEnd="none">
      {sectionIntro ? <ContentfulSectionIntro component={sectionIntro} /> : null}

      <Section as="div" paddingBlockStart="none" className={styles.RiverAccordionWrapper}>
        {riverAccordion ? (
          <ContentfulRiverAccordion component={riverAccordion} variant="gridline" className={styles.RiverAccordion} />
        ) : null}
      </Section>

      {cards ? <Cards component={cards} /> : null}
    </Section>
  )
}
